import { useQuery } from '@tanstack/react-query';

import type { ScopeSite } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';

interface ScopeSitesInput {
  contractIds?: string[];
}

interface ScopeSitesResponse {
  sites: ScopeSite[];
}

export const useScopeSites = (input: ScopeSitesInput) =>
  useQuery({
    queryKey: ['extranet', 'scope', 'sites', input] as const,
    queryFn: () => getExtranetApi().get<ScopeSitesInput, ScopeSitesResponse>('/v1/extranet/scope/sites', input),
    staleTime: 5 * 60 * 1000,
  });
